export default __webpack_public_path__ + "static/media/quickswap.959d598d.png";